import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { delay } from "./Utils";
import { createToast } from "./Toast";

const UpdateSubmission = (modal) => {
  const form = document.getElementById("update_submission_form");
  if (form) {
    const spinner = form.querySelector("button[type=submit] svg");
    const spinnerText = form.querySelector("button[type=submit] span");

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Saving...";

      const data = new FormData(form);
      data.append("action", "update_submission");

      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
          }
          delay(1000).then(() => {
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Save";

            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: "/submissions",
            });
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);

          spinner.classList.add("hidden!");
          spinnerText.textContent = "Save";

          createToast({
            type: "error",
            message: result.message,
            duration: 1000,
          });
        });
    });
  }
};

export { UpdateSubmission };
